import React, { useMemo } from 'react'
import {
  SelectProductContainer,
  SelectProductTitle,
} from 'Components/Elements/AddDomainModal/SingleDomain/AddDomainModal.styled'

import { useTranslation } from 'react-i18next'

import { GeneralSelect } from '@clickcease/cc-client-components-lib'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import i18n from 'Lib/i18n'
import { Products } from 'Types/Product'

const productsOptions = [
  {
    label: i18n.t('paid_marketing', { ns: 'domainManagement' }),
    value: 'paidMarketing',
    key: 'paidMarketingAllowed',
  },
  {
    label: i18n.t('bot_zapping', { ns: 'domainManagement' }),
    value: 'botZapping',
    key: 'botZappingAllowed',
  },
]

export const SelectProduct = ({
  onSelect,
  showOnlySelect,
  selected,
  disabled,
  disabledProducts,
}: {
  showOnlySelect?: boolean
  onSelect: (selection: { paidMarketing?: boolean; botZapping?: boolean }) => void
  selected?: { paidMarketing?: boolean; botZapping?: boolean }
  disabledProducts?: Array<Products | undefined>
  disabled?: boolean
}) => {
  const { t } = useTranslation('domainManagement')
  const { data: packagesData } = useGetPackagingLimits()

  const productsAllowed = useMemo(() => {
    if (!packagesData) return []
    return productsOptions.filter((product) => {
      return packagesData[product.key] && !disabledProducts?.includes(product.value as Products)
    })
  }, [packagesData, disabledProducts])

  const handleSelect = (selected: typeof productsAllowed) => {
    onSelect(
      selected.reduce(
        (acc, product) => ({
          ...acc,
          [product.value]: true,
        }),
        {}
      )
    )
  }

  return (
    <SelectProductContainer noPadding={showOnlySelect}>
      {!showOnlySelect && (
        <SelectProductTitle>{t('add_new_domain_modal.select_product')}</SelectProductTitle>
      )}
      <GeneralSelect
        options={productsAllowed}
        // pre-selected products
        defaultValue={productsAllowed.filter((product) => !!selected?.[product.value])}
        onChange={(selected) => handleSelect([...selected])}
        isDisabled={disabled}
        isMulti
      />
    </SelectProductContainer>
  )
}
